import { makeStyles } from "components/mui-core";

const useStyles = makeStyles()({
  root: {
    color: "inherit",
    fontWeight: "bold",
  },
});

const truncateText = (str, l) =>
  str.length <= l ? str : `${str.slice(0, l)}...`;

export const AppNotificationLink = ({ to, label }) => {
  const { classes: styles } = useStyles();

  return (
    <a
      className={styles.root}
      href={to}>
      {truncateText(label, 80)}
    </a>
  );
};
